import React from "react";
import {
  commonHeaderStyle,
  commonStyle,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import "../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";

const ActionModal = ({ open, setOpen }) => {
  let tableDataTop = [
    {
      name: "Run Reco across FY",
      checked: true,
    },
    {
      name: "Run Fuzzy logic",
      checked: true,
    },
    {
      name: "Include Non-availed ITC",
      checked: true,
    },
  ];

  let tableDataBottom = [
    {
      name: "Tolerance",
      checked: true,
    },
    {
      name: "Taxable Value",
      checked: true,
    },
    {
      name: "Taxes",
      checked: false,
    },
  ];

  const columnsTop = [
    {
      dataField: "name",
      text: "Reco Details",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "50%",
      },
    },
    {
      dataField: "Checkbox",
      text: "Selection",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "50%",
      },
      formatter: (cell, row) => {
        return <input type="checkbox" checked={row.checked} />;
      },
    },
  ];
  const columnsBottom = [
    {
      dataField: "name",
      text: "Reco ID",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "50%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        display: "none",
      },
    },
    {
      dataField: "name",
      text: "Reco ID",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "50%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        display: "none",
      },
      formatter: (cell, row) => {
        return <input type="checkbox" checked={row.checked} />;
      },
    },
  ];
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={open}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Reco Details"}</Typography>
          <CloseIcon
            onClick={() => setOpen(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        <div
          className="light-border-gstr2a2bnew-table"
          style={{
            marginTop: "0.6em",
          }}
        >
          <BootstrapTable
            keyField="name"
            data={tableDataTop}
            columns={columnsTop}
            rowStyle={rowStyle2}
          />
        </div>
        <div
          className="light-border-gstr2a2bnew-table"
          style={{
            marginTop: "1em",
          }}
        >
          <BootstrapTable
            keyField="name"
            data={tableDataBottom}
            columns={columnsBottom}
            rowStyle={rowStyle2}
          />
        </div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default ActionModal;
